// This file is modified during CI builds. Do not change this
// file unless you know what you are doing
const APPLICATION_VERSION = "v1.455.89-feature-tss-3096-persist-filters-per-tab.1";

export const getApplicationVersion = (): string => APPLICATION_VERSION;
